import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "ReadingPaneItem"*/ './lazyIndex'),
    { name: 'ReadingPaneItem' }
);

export const ItemReadingPane: typeof lazyIndex.ItemReadingPane = createLazyComponent(
    lazyModule,
    m => m.ItemReadingPane
);
export const PartialLoadingShimmer: typeof lazyIndex.PartialLoadingShimmer = createLazyComponent(
    lazyModule,
    m => m.PartialLoadingShimmer
);
